import { render, staticRenderFns } from "./AlteracaoNormativa.vue?vue&type=template&id=9c99498c"
import script from "./AlteracaoNormativa.vue?vue&type=script&lang=ts"
export * from "./AlteracaoNormativa.vue?vue&type=script&lang=ts"
import style0 from "./css/main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports